import React from 'react';
import { NavBar } from './components/navBar/NavBar';
import AppRoutes from './routes/AppRoutes';
import { Footer } from './components/footer/Footer';
// import {ChatBot} from './components/chatBot/ChatBot';

function App() {
  return (
    <>
      <NavBar />
      <AppRoutes />
      <Footer />
      {/* <ChatBot /> */}
    </>
  );
}

export default App;